import { absolutePath } from "../absolutePath";

export const billingPortal = {
  create: () => absolutePath(`account_payment_processors/billing_portals`, {}),
};
